import React from 'react'

const Experiments = () => {
  return (
    <div>Experiments</div>
  )
}

export default Experiments